<template>
  <div class="keyword-settings">
    <div class="dropdown open">
      <button class="btn btn-default" type="button" id="keywordSettingsDropdownMenuButton" v-on:click="toggleDropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-key" aria-hidden="true"></i> Edit keyword settings
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="keywordSettingsDropdownMenuButton" id="divShowKeywordSettings" v-bind:style="[ dropdownVisible ? {'display':'block'} : {'display':'none'} ]">
        <strong>Select a keyword difficulty</strong> <span class="text-right close-btn" v-on:click="toggleDropdown"><i class="fa fa-times" aria-hidden="true"></i></span>
        <div class="options">
          <input type="radio" id="radKeywordDifficultyEasy" value="1" v-model.number="keywordDifficulty" @change="saveChapter(1)" /> <label for="radKeywordDifficultyEasy">Easy</label><br>
          <input type="radio" id="radKeywordDifficultyMod" value="2" v-model.number="keywordDifficulty" @change="saveChapter(2)" /> <label for="radKeywordDifficultyMod">Moderate</label><br>
          <input type="radio" id="radKeywordDifficultyDif" value="3" v-model.number="keywordDifficulty" @change="saveChapter(3)" /> <label for="radKeywordDifficultyDif">Difficult</label>
        </div>
        <hr />
        {{description}}<br /><br />
        <strong>Example:</strong><br />
        'Cerebral Edema' =  <span class="clex-keyword">{{example}}</span>
      </div>
    </div>
  </div>

</template>


<script> 

import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {

    beforeMount() {
      this.keywordDifficulty = (this.chapter && this.chapter.KeywordDifficulty) ? this.chapter.KeywordDifficulty : 1;
  },

  methods: {
    saveChapter(difficulty) {
      // this line is here for Windows Edge and Safari - it seems the Change event fires before keywordDifficulty is updated in vue
      this.keywordDifficulty = difficulty;


      if (this.chapter) {
        const changes = Object.assign({}, this.chapter, { KeywordDifficulty: this.keywordDifficulty });
        this.$store.dispatch('updateChapter', {
          id: this.chapter.id,
          changes,
          callback: (err) => {
            Toast.success('Keyword difficulty updated');
          },
        });
      }
    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    }
  },

  data() {
    return {
      keywordDifficulty: 1,
      dropdownVisible: false
    }
  },

  props: {
    chapterId: Number,
  },

  computed: {

    chapter() {
      return this.$store.state.chapters[this.$route.params.chapterId || this.chapterId];
    },

    example() {
      switch (parseInt(this.keywordDifficulty)) {
        case 1:
          return '********  *****';
          break;
        case 2:
          return '-----  -----';
          break;
        case 3:
          return ' ? ';
          break;
      }
    },
    description() {
      switch (parseInt(this.keywordDifficulty)) {
        case 1:
          return 'Hints at number of characters & words';
          break;
        case 2:
          return 'Hints at the number of words';
          break;
        case 3:
          return 'No hints';
          break;
      }
    }
  },
}
</script>


<!-- Scoped styling -->
<style lang="scss">
  .keyword-settings {margin-top: 0px;}
  .dropdown-menu {
    width:250px;
    padding: 10px 10px;
    .options { margin: 10px 0 0 10px; }
    hr {margin:5px 0 10px 0;}
    .close-btn {position:absolute;top:10px;right:10px;cursor:pointer;}
  }

</style>



// WEBPACK FOOTER //
// KeywordSettings.vue?674e5711